import {FC} from "react";
import styled from "styled-components";
import {AdsDrawerInfoFragment} from "./__generated__/AdsInform.fragment.generated";


const Container = styled.div`
  padding: 2.4rem;
  line-height: 130%;
  margin-top: -2.4rem;
  margin-left: -2.4rem;
  background: #e6ebef;
  margin-bottom: 2.5rem;
  width: calc(100% + 4.8rem);
`;


interface AdsDrawerInformProps {
  info: AdsDrawerInfoFragment
}

const AdsInform:FC<AdsDrawerInformProps> = ({ info }) => {
  return (
      <Container>
        <p>Информация о приборе:</p>
        <h2>{info.device.category.name} {info.device.manufacturer.name} {info.device.model.name}</h2>
        <p>ID: {info.code}</p>
      </Container>
  )
}

export default AdsInform;
